import ProjectListView from "../presentation/views/ProjectListView.vue";
import ProjectDetailView from "../presentation/views/ProjectDetailView.vue";
export const projectsRoutes = [
    {
        path: "/projects",
        name: "ProjectList",
        component: ProjectListView,
        meta: { requiresAuth: true, titleKey: "projects.title" },
    },
    {
        path: "/projects/:projectId",
        name: "ProjectDetail",
        component: ProjectDetailView,
        meta: { requiresAuth: true, titleKey: "projects.title" },
    },
];
export const projectsNavigationItems = [
    {
        labelKey: "projects.title",
        path: "/projects",
        meta: { requiresAuth: true },
    },
];
